import { usePreloadCacheContext } from 'framework/hooks/usePreloadCacheContext';
import { IUserSummary } from 'gen/ApiClient';
import { useMemo } from 'react';
import { UsersCacheContext } from './UsersCacheContext';

export const useFindUser = (userId: string | undefined): IUserSummary | undefined => {
	const [data] = usePreloadCacheContext(UsersCacheContext);
	return useMemo(() => (userId === undefined ? undefined : data?.users.find(t => t.id === userId)), [data, userId]);
};
